import {
  ComponentRef,
  Directive,
  ElementRef,
  inject,
  OnInit,
  ViewContainerRef
} from '@angular/core';
import { ControlContainer, NgControl, NgModel } from '@angular/forms';
import { merge, Observable, skip, startWith } from 'rxjs';
import { ControlErrorComponent } from '../components/controllers/control-error/control-error.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { classChangeObservable } from '../utils/class-change-observable.util';

@UntilDestroy()
@Directive({
  selector: `
    [ngModel]:not([withoutValidationErrors]),
    [formControl]:not([withoutValidationErrors]),
    [formControlName]:not([withoutValidationErrors]),
    [formGroupName]:not([withoutValidationErrors]),
    [ngModelGroup]:not([withoutValidationErrors])
  `
})
export class DynamicValidatorMessageDirective implements OnInit {
  private vcr: ViewContainerRef = inject(ViewContainerRef);
  private elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  // private parentContainer: ControlContainer | null = inject(ControlContainer, {
  //   optional: true
  // });
  private componentRef: ComponentRef<ControlErrorComponent> | undefined;

  private ngControl: NgControl | ControlContainer =
    inject(NgControl, { self: true, optional: true }) ||
    inject(ControlContainer, { self: true });

  private classChanges$: Observable<void> = classChangeObservable(
    this.elementRef.nativeElement
  );

  // private get form(): NgForm | FormGroupDirective | null {
  //   return this.parentContainer?.formDirective as NgForm | FormGroupDirective;
  // }

  ngOnInit() {
    if (!this.ngControl.control) {
      throw Error('DynamicValidatorMessageDirective: ngControl is not defined');
    }

    merge(this.ngControl.control.statusChanges, this.classChanges$)
      .pipe(
        startWith(this.ngControl.control.status),
        skip(this.ngControl instanceof NgModel ? 1 : 0),
        untilDestroyed(this)
      )
      .subscribe(() => {
        if (this.ngControl.errors && this.ngControl.control?.touched) {
          if (this.componentRef == null) {
            this.componentRef = this.vcr.createComponent(ControlErrorComponent);
          }

          this.componentRef.setInput('errors', this.ngControl.errors);
          this.componentRef.changeDetectorRef.markForCheck();
        } else {
          this.componentRef?.destroy();
          this.componentRef = undefined;
        }
      });
  }
}
